


























































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import VueApexCharts from 'vue-apexcharts';

@Component({
    components: {
        apexchart: VueApexCharts,
    },
    name: 'environmental-control-chart',
})
export default class EnvironmentalControlChart extends Vue {
    @Prop({ required: true })
    name!: string;

    @Prop({ required: true })
    temperatureOptions!: {
        categories: string[];
        series: {
            name: string;
            data: number[];
        }[];
    };

    @Prop({ required: true })
    humidityOptions!: {
        categories: string[];
        series: {
            name: string;
            data: number[];
        }[];
    };

    temperatureParameterSelected: boolean = true;

    get temperatureAndHumidityOptions() {
        return {
            chart: {
                type: 'area',
                toolbar: {
                    show: false,
                },
                defaultLocale: 'es',
                locales: [
                    {
                        name: 'es',
                        options: {
                            months: [
                                'Enero',
                                'Febrero',
                                'Marzo',
                                'Abril',
                                'Mayo',
                                'Junio',
                                'Julio',
                                'Agosto',
                                'Septiembre',
                                'Octubre',
                                'Noviembre',
                                'Diciembre',
                            ],
                            shortMonths: [
                                'Ene',
                                'Feb',
                                'Mar',
                                'Abr',
                                'May',
                                'Jun',
                                'Jul',
                                'Ago',
                                'Sep',
                                'Oct',
                                'Nov',
                                'Dic',
                            ],
                            days: [
                                'Domingo',
                                'Lunes',
                                'Martes',
                                'Miércoles',
                                'Jueves',
                                'Viernes',
                                'Sábado',
                            ],
                            shortDays: ['Dom', 'Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab'],
                            toolbar: {
                                download: 'Download SVG',
                                selection: 'Selection',
                                selectionZoom: 'Selection Zoom',
                                zoomIn: 'Zoom In',
                                zoomOut: 'Zoom Out',
                                pan: 'Panning',
                                reset: 'Reset Zoom',
                            },
                        },
                    },
                ],
            },
            dataLabels: {
                enabled: false,
            },
            stroke: {
                curve: 'smooth',
            },
            colors: ['#603E99', '#94CA4E'],
            yaxis: {
                labels: {
                    show: true,
                    style: {
                        fontSize: '11px',
                    },
                },
                title: {
                    text: this.temperatureParameterSelected ? 'Temperatura (°C)' : 'Humedad (%)',
                },
            },
            xaxis: {
                type: 'datetime',
                datetimeUTC: true,
                categories: this.temperatureParameterSelected
                    ? this.temperatureOptions.categories
                    : this.humidityOptions.categories,
                labels: {
                    datetimeFormatter: {
                        year: 'yyyy',
                        month: 'dd MMM',
                    },
                },
            },
            tooltip: {
                x: {
                    formatter: function(val) {
                        const options = {
                            weekday: 'long',
                            year: 'numeric',
                            month: 'long',
                            day: 'numeric',
                            timeZone: 'UTC',
                        };
                        return new Date(val).toLocaleString('es-es', options);
                    },
                },
            },
        };
    }
}
